import React from 'react';
import {
  demandConstraintStageIndex,
  type DemandStageCount,
} from './driveDemandStageProgression';
import styles from '../ControlBridge.module.css';

export interface DriveDemandStageFunnelProps {
  stages: DemandStageCount[];
  compact?: boolean;
}

export const DriveDemandStageFunnel: React.FC<DriveDemandStageFunnelProps> = ({
  stages,
  compact = false,
}) => {
  if (stages.length === 0) return null;
  const constraintIdx = demandConstraintStageIndex(stages);

  return (
    <div
      className={compact ? styles.driveDemandFunnelCompact : styles.driveDemandFunnel}
      data-testid="drive-demand-stage-funnel"
      aria-label="Demand stage progression"
    >
      {!compact ? (
        <div className={styles.driveDemandFunnelTitle}>Demand drop-off</div>
      ) : null}
      <div className={styles.driveDemandFunnelStages} role="list">
        {stages.map((stage, index) => {
          const isConstraint = constraintIdx === index;
          return (
            <div
              key={stage.laneId}
              className={[
                styles.driveDemandFunnelStage,
                isConstraint ? styles.driveDemandFunnelStageConstraint : '',
              ]
                .filter(Boolean)
                .join(' ')}
              role="listitem"
            >
              <div className={styles.driveDemandFunnelStageHead}>
                <span className={styles.driveDemandFunnelStageName}>{stage.laneName}</span>
                <span className={styles.driveDemandFunnelStageCount}>{stage.count}</span>
              </div>
              <div className={styles.driveDemandFunnelBarTrack} aria-hidden>
                <div
                  className={styles.driveDemandFunnelBarFill}
                  style={{ width: `${Math.max(stage.barWidthPct, stage.count > 0 ? 8 : 0)}%` }}
                />
              </div>
              {index > 0 && stage.dropOffPct != null ? (
                <span className={styles.driveDemandFunnelDropOff} aria-label={`Drop-off ${stage.dropOffPct}%`}>
                  −{stage.dropOffPct}%
                </span>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};
